import { Skeleton, Stack, Typography } from '@mui/material';
import { TextBlock } from 'common/ui/TextBlock';
import { CvViewer } from 'components/CvViewer';
import { CandidateProfileDetails } from 'modules/candidate-profile/types/CandidateProfileDetails';

export type CandidateProfileProfileTabProps = {
  candidateProfile: CandidateProfileDetails | undefined | null;
};

export const CandidateProfileProfileTab: React.FC<
  CandidateProfileProfileTabProps
> = ({ candidateProfile }) => {
  if (!candidateProfile) {
    return <Skeleton variant="rectangular" height="100%" width="100%" />;
  }

  const formatJobExperience = (job: any) => {
    const parts = [];
    if (job.jobTitle) parts.push(job.jobTitle);
    if (job.companyName) parts.push(`at ${job.companyName}`);
    return parts.join(' ');
  };

  const formatEducation = (edu: any) => {
    const parts = [];
    if (edu.course) parts.push(edu.course);
    if (edu.institution) parts.push(`at ${edu.institution}`);
    return parts.join(' ');
  };

  return (
    <Stack direction="row" gap="50px">
      <Stack width="862px">
        {candidateProfile.latestCvS3Key && (
          <>
            <Typography>Latest CV</Typography>
            <CvViewer
              cvS3Key={candidateProfile.latestCvS3Key}
              cvParsedText={candidateProfile.latestCvText}
            />
          </>
        )}
      </Stack>
      <Stack flex={1} gap="40px">
        {candidateProfile.jobs && candidateProfile.jobs.length > 0 && (
          <TextBlock
            variant="subhead"
            title="Experience"
            subtitle={
              <>
                {candidateProfile.jobs.map((job, index) => (
                  <li key={index} style={{ marginLeft: '14px' }}>
                    {formatJobExperience(job)}
                  </li>
                ))}
              </>
            }
          />
        )}
        {candidateProfile.education &&
          candidateProfile.education.length > 0 && (
            <TextBlock
              variant="subhead"
              title="Education"
              subtitle={
                <>
                  {candidateProfile.education.map((edu, index) => (
                    <li key={index} style={{ marginLeft: '14px' }}>
                      {formatEducation(edu)}
                    </li>
                  ))}
                </>
              }
            />
          )}
        {candidateProfile.skills && candidateProfile.skills.length > 0 && (
          <TextBlock
            variant="subhead"
            title="Skills"
            subtitle={candidateProfile.skills.join(', ')}
          />
        )}
        {candidateProfile.tags && candidateProfile.tags.length > 0 && (
          <TextBlock
            variant="subhead"
            title="Tags"
            subtitle={candidateProfile.tags.join(', ')}
          />
        )}
        {candidateProfile.originalSource && (
          <TextBlock
            variant="subhead"
            title="Original Source"
            subtitle={candidateProfile.originalSource}
          />
        )}
      </Stack>
    </Stack>
  );
};
